import $ from 'jquery';
import 'air-datepicker/air-datepicker';
import './Language/Datepicker-de';
import './Language/Datepicker-en';

var config = {};
var $body = $('body');
if ($body.hasClass('language-de')) {
    config.language = 'de';
} else {
    config.language = 'en';
}

$('.datepicker-input').datepicker(config);
